var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngineeringStation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 40,
    height: 28,
    rx: 2,
    fill: "#2C5F8A",
    stroke: "#1A4971",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 34,
    height: 20,
    rx: 1,
    fill: "#1A202C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#2B6CB0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17,
    r: 3,
    fill: "#63B3ED",
    stroke: "#90CDF4",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 16,
    height: 4,
    rx: 0.5,
    fill: "#2B6CB0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 16,
    height: 4,
    rx: 0.5,
    fill: "#2B6CB0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 28,
    height: 2,
    rx: 0.5,
    fill: "#2B6CB0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 34,
    width: 12,
    height: 4,
    fill: "#2C5F8A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 38,
    width: 28,
    height: 2,
    rx: 1,
    fill: "#2C5F8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineeringStation);
export default __webpack_public_path__ + "static/media/engineering_station.1ca9c8aac979c642f1f4dd0d54625fac.svg";
export { ForwardRef as ReactComponent };